import React from 'react';
import Breakdown from '../../../../../components/Builder/Breakdown';
import * as BuilderUI from '../../../../../components/Builder/BuilderUI';
import {
  ExpressionModeKey,
  QueryType,
  TimeUnit,
} from '../../../../../utils/apollo/graphqlSchema';
import { useAppSelector } from '../../../../../redux/hooks';
import { RowType } from '../../../../../redux/slices/oldBuilder';
import { MAX_BREAKDOWN_GROUPS_IN_HISTOGRAM } from '../../../../../config/constants';
import { builderSelectedOptionsSelector } from '../../../../../redux/selectors/builder';
import { assertCondition } from '../../../../../utils/types';

/**
 * Breakdown section in Query has limitations in Histogram mode with
 * time unit ALL_TIME. User is allowed to select only 1 group OR several
 * segments.
 *
 * For all other modes - there are no limitations
 */

interface IProps {
  expressionMode: ExpressionModeKey;
}

const QueryBuilderBreakdown = ({ expressionMode }: IProps) => {
  const groups = useAppSelector(({ builder }) => builder.breakdown.groups);
  const segments = useAppSelector(
    ({ builder }) => builder[RowType.breakdownCohorts],
  );
  const selectedOptions = useAppSelector((state) =>
    builderSelectedOptionsSelector(state),
  );

  assertCondition(selectedOptions?.type === QueryType.Expression);

  const { timeUnit } = selectedOptions;

  if (expressionMode === ExpressionModeKey.Histogram) {
    // In Histogram mode Breakdown section is available only for
    // ALL_TIME time unit
    if (timeUnit !== TimeUnit.AllTime) {
      return null;
    }

    const groupLimitReached =
      groups.length === MAX_BREAKDOWN_GROUPS_IN_HISTOGRAM;
    const activeSegments = segments.length > 0;

    const enableAddGroups = !groupLimitReached && !activeSegments;

    return (
      <>
        <Breakdown
          enableAddGroups={enableAddGroups}
          enableAddSegments={!groupLimitReached}
        />
        <BuilderUI.HorizontalDivider />
      </>
    );
  }

  // For all other modes - render Breakdown as usual
  return (
    <>
      <Breakdown />
      <BuilderUI.HorizontalDivider />
    </>
  );
};

export default QueryBuilderBreakdown;
